import QuillEditor from "../util/QuillEditor";
import styles from "./PageEdit.module.css"


// component
import TextInput from "./TextInput";
import ImageSelector from "./ImageSelector";

/**
 * A reusable section editor component.
 *
 * @param {bool} setImage - Display thee ability to set an image for the section.
 * @param {string} sectionKey - The section key (e.g., "Sec1", "PageHeader"), used as key in the json data.
 * @param {string} header - The section header text.
 * @param {string} secName - The section name.
 * @param {string} text - The section text.
 * @param {string} image - The section image URL.
 * @param {Function} updateField - Function to update the parent state.
 *
 * @example
 * <PageInfoEdit setImage={True} sectionKey="Sec1" header={data.Sec1.header} updateField={updateField} />
 */

export default function PageInfoEdit({setImage, sectionKey, header, text, imageUrl, id, secName, updateField}) {

    return(
        <div className={styles.pageInfoEdit}>
             <h2>{header}</h2>

            {/* Header Input */}
            <TextInput
                label={"Header:"}
                value={header}
                onChange={(e) => updateField(sectionKey, "header", e.target.value)}
            />

            {/* Content id */}
            <TextInput
                label={"Id:"}
                value={id}
                onChange={(e) => updateField(sectionKey, "secId", e.target.value)}
            />

            {/* content section Name */}
            <TextInput
                label={"Sektion navn:"}
                value={secName}
                onChange={(e) => updateField(sectionKey, "secName", e.target.value)}
            />

            {/* Content Editor */}
            <QuillEditor
                value={text || ""}
                onChange={(value) => updateField(sectionKey, "text", value)}
                placeholder="Write your content here..."
            />

            

            {/* Image Upload */}
            {setImage ?( <ImageSelector 
                value={imageUrl || ""}
                updateField={(val) => updateField(sectionKey, "imageUrl", val)}
            />): null}
        </div>
    );

}